// extracted by mini-css-extract-plugin
export default {"value":"NoneValue_value__YXhYo"};